/* eslint-disable no-unused-vars */
import {
  CButton,
  CCol,
  CLabel,
  CRow,
  CSpinner,
  CInputGroup,
} from "@coreui/react";
import React, { useEffect, useState } from "react";

import { apiCall, apiCallResponse } from "src/_apiConfig/apiCall";
import { useParams } from "react-router-dom";
import Auth from "src/auth";
import CommonList from "../../../common/CommonList";
import TableButtonAnchor from "../../../common/Table/TableButtonAnchor";
import TableButtonClick from "../../../common/Table/TableButtonClick";

const ViewSanctionLatter = () => {
  const { authenticated } = Auth();
  const [sanctionLetterByBidderdata, setuserData] = useState();
  const [loading, setloading] = useState(false);
  const [pageLimit, setpageLimit] = useState(0);
  const [disabledprev, setdisabledprev] = useState(false);
  const [disablednext, setdisablednext] = useState(false);
  const [itemPerPage, setItermPerPage] = useState(10);
  const { id } = useParams("id");

  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage

  // useEffect(() => {
  //   getTenderList(true);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageLimit, textField, orderClick, itemPerPage]);

  useEffect(() => {
    setloading(true);
    //resetPageLimit();
    getPageCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getTenderList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, itemPerPage]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getTenderList();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  //Pagging Disabled /Enable manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  //Pagging manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };
  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };

  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(
        `Bidder/GetBidderByTenderId?tenderId=${Number(id)}`
      ).then((res) => {
        if (res.success) paggingManage(parseInt(res.data.length) || 0);
        else paggingManage(0, false);
      });
    }
  };

  const reset = () => {
    setpageLimit(0);
  };

  const getTenderList = async () => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `Bidder/GetBidderByTenderId?tenderId=${Number(
          id
        )}&$skip=${pageLimit}&$top=${parseInt(itemPerPage)}`
      )
        .then((res) => {
          if (res.success) {
            setuserData(res.data);
            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          } else {
            setuserData();
            paggingManage(0, false);
          }
        })
        .finally(() => {
          setloading(false);
        });
    }
    // setloading(true);
    // const header = new Headers();
    // const response = await apiCall(
    //   `Bidder/GetBidderByTenderId?tenderId=${Number(id)}`,
    //   "GET",
    //   header,
    //   null
    // );

    // const jsonobj = await response.json();
    // if (response.status === 200) {
    //   setuserData(jsonobj);
    // }

    // setloading(false);

    // pageLimit === 0 ? setdisabledprev(true) : setdisabledprev(false);
  };

  const handleDownloadSanctionLetterByBidder = async (tenderid, userId) => {
    const header = new Headers();
    const response = await apiCall(
      `Bidder/DownloadBidderSanction?tenderId=${Number(
        tenderid
      )}&userId=${Number(userId)}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response;
    jsonobj.blob().then((blob) => {
      const fileURL = window.URL.createObjectURL(blob);
      // Setting various property values
      let alink = document.createElement("a");
      alink.href = fileURL;
      alink.download = tenderid + "" + userId + ".pdf";
      alink.click();
    });
  };

  let scopedSlotsList = {
    viewSanctionLetterByBidder: (item, index) => {
      return (
        <TableButtonAnchor
          fileName={item.path}
          path={item.path}
          buttonName={"View"}
        />
      );
    },
    DownloadSanctionLetterByBidder: (item, index) => {
      return (
        <TableButtonClick
          isDisplayAllow={true}
          buttonName={"Download"}
          onClick={() =>
            handleDownloadSanctionLetterByBidder(item.tenderId, item.userId)
          }
        />
      );
    },
  };
  let fields = [
    {
      key: "emailId",
      _style: { width: "15%" },
      label: <div>Email Address</div>,
    },
    {
      key: "tenderId",
      _style: { width: "15%" },
      label: <div>Tender Id</div>,
    },
    {
      key: "bidderName",
      _style: { width: "15%" },
      label: <div>Bidder Name</div>,
    },
    {
      key: "tenderNo",
      _style: { width: "15%" },
      label: <div>TenderNo</div>,
    },
    {
      key: "bidderMobile",
      _style: { width: "15%" },
      label: <div>Bidder Mobile</div>,
    },
    {
      key: "companyName",
      _style: { width: "15%" },
      label: <div>Company Name</div>,
    },
    {
      key: "viewSanctionLetterByBidder",
      label: "View Sanction",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "DownloadSanctionLetterByBidder",
      label: "Download Sanction",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];

  return (
    <CommonList
      items={sanctionLetterByBidderdata}
      fields={fields}
      listName="Bidder Wise Sanction Letters List"
      loading={loading}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      scopedSlots={scopedSlotsList}
      isBackButton={true}
      backButtonTo={
        authenticated.role === "CGMF" ? "/tender/tenderlist" : "/tenderlist"
      }
    />
  );
};
export default ViewSanctionLatter;
